// src/components/AppLayout.jsx
import React from "react";
import { Box } from "@mui/material";
import TopBar from "./TopBar";
import Footer from "./Footer";

/**
 * AppLayout component for the main application layout.
 * Provides consistent layout structure with TopBar and optional Footer.
 *
 * Props:
 * - user: Current user object
 * - children: React.ReactNode
 * - showFooter?: boolean (default: true) — whether to render the global Footer
 */
const AppLayout = ({ user, children, showFooter = true }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        margin: 0,
        padding: 0,
        backgroundColor: "#ffffffff",
      }}
    >
      <TopBar user={user} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          m: 0,
          width: "100%",
          backgroundColor: "#ffffffff",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>

      {showFooter && <Footer />}
    </Box>
  );
};

export default AppLayout;
